import { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Check, X, ClipboardList, KeyRound, UserPlus } from 'lucide-react';

export default function Solicitudes() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try { const data = await api.getPendingRequests(); setRequests(data); }
    catch (error) { /* handled */ } finally { setLoading(false); }
  };

  useEffect(() => { fetchRequests(); }, []);

  const handleApprove = async (userId) => {
    try { const result = await api.approveRequest(userId); toast.success(result.message); fetchRequests(); }
    catch (error) { const detail = error.response?.data?.detail; toast.error(typeof detail === 'string' ? detail : 'Error al aprobar'); }
  };

  const handleReject = async (userId) => {
    if (!window.confirm('Rechazar esta solicitud?')) return;
    try { await api.rejectRequest(userId); toast.success('Solicitud rechazada'); fetchRequests(); }
    catch (error) { toast.error('Error al rechazar'); }
  };

  return (
    <div className="space-y-6" data-testid="solicitudes">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-[#0A0A0A]">Solicitudes</h1>
        <p className="text-[13px] text-gray-500 mt-0.5">Aprobar o rechazar solicitudes de ingreso y restablecimiento</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-32"><div className="text-gray-500 text-[13px]">Cargando...</div></div>
      ) : requests.length === 0 ? (
        <div className="mac-card p-8 text-center"><ClipboardList size={40} className="mx-auto text-gray-200 mb-3" /><p className="text-gray-500">No hay solicitudes pendientes</p></div>
      ) : (
        <div className="mac-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead><tr><th className="table-header">Nombre</th><th className="table-header">Tipo</th><th className="table-header">Rol</th><th className="table-header">Acciones</th></tr></thead>
              <tbody>
                {requests.map(request => (
                  <tr key={request.id} className="table-row">
                    <td className="table-cell font-medium text-[#0A0A0A]">{request.nombre} {request.apellido || ''}</td>
                    <td className="table-cell">
                      {request.status === 'pending_reset' ? (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200" data-testid={`type-reset-${request.id}`}>
                          <KeyRound size={12} /> Restablecimiento
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200" data-testid={`type-new-${request.id}`}>
                          <UserPlus size={12} /> Nuevo registro
                        </span>
                      )}
                    </td>
                    <td className="table-cell capitalize text-gray-600">{request.role}</td>
                    <td className="table-cell">
                      <div className="flex items-center gap-2">
                        <button onClick={() => handleApprove(request.id)} className="btn-primary px-3 py-1.5 flex items-center gap-1" data-testid={`approve-${request.id}`}><Check size={14} /> Aprobar</button>
                        <button onClick={() => handleReject(request.id)} className="btn-secondary px-3 py-1.5 flex items-center gap-1" data-testid={`reject-${request.id}`}><X size={14} /> Rechazar</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
